import {RemoteCollectionStore, StoreBuilder} from '@softline/core';
import {Vkforg} from '../context/vkforg-context/data/vkforg';

export const VkforgStore = new StoreBuilder(RemoteCollectionStore.create<Vkforg>()).value;
